import { Tab, Tabs } from '@mui/material';
import { DashboardYearFilter } from '../components/DashboardYearFilter';
import { useStudentServiceData } from '../contexts';
import { StudentServiceMetric } from '../types';

export const StudentServiceFilterControls = ({ showMetric = true }: { showMetric?: boolean }) => {
    const { filter, updateFilter, activeSchoolYear, metric, setMetric } = useStudentServiceData();
    return <DashboardYearFilter idPrefix="student-service" years={filter.schoolYears} activeSchoolYear={activeSchoolYear}
        onApply={schoolYears => updateFilter({ schoolYears })}>
        {showMetric && <Tabs value={metric} onChange={(_, value: StudentServiceMetric) => setMetric(value)}>
            <Tab label="Participation Rate" value="participantRate" />
            <Tab label="Average Hours" value="averageHours" />
        </Tabs>}
    </DashboardYearFilter>;
};
